/**
 * FAQ Section JavaScript
 * Handles accordion toggle functionality for FAQ items
 * Allows one FAQ to be open at a time
 */

document.addEventListener('DOMContentLoaded', function() {
  // Get all FAQ question elements
  const faqQuestions = document.querySelectorAll('.p-herbs-faq-question');
  
  faqQuestions.forEach(function(question) {
    question.addEventListener('click', function() {
      const faqItem = this.parentElement; // Get the parent FAQ item container
      const isActive = faqItem.classList.contains('active'); // Check if it's already active
      
      // Close all other FAQs
      document.querySelectorAll('.p-herbs-faq-item').forEach(function(item) {
        item.classList.remove('active');
        const answer = item.querySelector('.p-herbs-faq-answer');
        if (answer) {
          answer.style.display = 'none'; // Hide all answers
        }
      });
      
      // Toggle the current FAQ's active state
      if (isActive) {
        faqItem.classList.remove('active'); // Remove the active class
        const answer = faqItem.querySelector('.p-herbs-faq-answer');
        if (answer) {
          answer.style.display = 'none'; // Hide the answer
        }
      } else {
        faqItem.classList.add('active'); // Add the active class
        const answer = faqItem.querySelector('.p-herbs-faq-answer');
        if (answer) {
          answer.style.display = 'block'; // Show the answer
        }
      }
    });
  });
});
